export function getCountryLabelKey(code, financingCountries = []) {
    const match = (financingCountries || []).find((c) => c && c.code === code)
    return (match && match.translationKey) || null
}
